import { useEffect } from 'react';
import Script from '../Script';

// {
//   status: 'info' | 'warning' | 'danger';
//   description: string; // a friendly message to your users about the current state of the kview
// }

declare global {
  // oxlint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    Kustomer?: {
      updateStatus: (status: {
        status: 'info' | 'warning' | 'danger';
        description: string;
      }) => void;
      initialize: (callback: (context: unknown) => void) => void;
      // Event listener
      on: (
        event:
          | 'context'
          | 'flags'
          | 'theme'
          | 'initialize'
          | 'number-dialed'
          | 'routing-status-change'
          | 'kustomer-typing-status-changed',
        callback: (context: unknown, meta?: { userRoles?: unknown }) => void,
      ) => void;

      // Modal and layout control
      resize: (options?: {
        width?: string | number;
        height?: string | number;
        modal?: boolean;
      }) => void;
      openCustomerEvent: (customerId: string, eventId: string) => void;
      open: () => void;
      close: () => void;
    };
  }
}

export function kustomerUpdateStatus(status: {
  status: 'info' | 'warning' | 'danger';
  description: string;
}) {
  if (window.Kustomer) {
    window.Kustomer.updateStatus(status);
  }
}

export function kustomerOpenCustomerEvent(customerId: string, eventId: string) {
  if (window.Kustomer) {
    window.Kustomer.openCustomerEvent(customerId, eventId);
  }
}

/**
 * Side-effect component to trigger a resize through the Kustomer Cards SDK on any change to the `document.body`.
 * @see https://developer.kustomer.com/kustomer-apps-platform/docs/card-js
 */
function KustomerResize() {
  useEffect(() => {
    const observer = new MutationObserver(() => window.Kustomer?.resize());

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });

    return () => observer.disconnect();
  }, []);

  return null;
}

/**
 * Kustomer integration component.
 * Adds the Kustomer Card JS script and handles setup for `DynamicCard` resizing.
 * @see https://developer.kustomer.com/
 * @see https://developer.kustomer.com/kustomer-apps-platform/docs/card-js
 */
export default function Kustomer() {
  return (
    <>
      <Script
        src="https://cdn.kustomerapp.com/card-js/latest/kustomer-card.min.js"
        // initially trigger resize once loaded
        onLoad={() => window.Kustomer?.resize()}
      />
      <KustomerResize />
    </>
  );
}
